import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  downloadArquivo,
  IconPaths,
  ModalSize,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { Aso } from '../../components/modal/Aso'
import { getAtendimentoById, validateAso } from '../../../../atendimento/core/_requests'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { generateAso } from '../../core/_request'

type Props = {
  atendimento: AtendimentoList
}

export const GenerateAsoActionsCell: FC<Props> = ({ atendimento }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const { id } = atendimento
  const nome = `ASO ${atendimento.protocolo ?? ''}`.trim()

  // Edição do ASO (dados do atestado + pendências que impedem a geração).
  const openAso = () =>
    showModal({
      title: 'Emitir ASO',
      content: <Aso id={id} />,
      size: ModalSize.ExtraLarge,
      fetchers: {
        atendimento: () => getAtendimentoById(id),
        pendencias: () => validateAso(id),
      },
    })

  const handleGenerate = async () => {
    try {
      showAlertLoading()
      const arquivo = await generateAso(id)
      Swal.close()
      downloadArquivo(arquivo)
      showToast({ variant: 'success', title: `${nome} gerado.` })
      // Gerado sai da lista de pendentes.
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Editar', onClick: openAso, icon: IconPaths.Pen }}
      items={[{ label: 'Gerar ASO', onClick: handleGenerate }]}
    />
  )
}
